import {Component, OnInit, ViewChild} from '@angular/core';
import {PageHeaderBarConfig, PageSubheaderBarConfig} from '../../../fw/pages/page-config-api';
import {BreadcrumService, BreadcrumStep } from '../../../fw/services/breadcrum.service';
import {AutoUnsubscribe} from '../../../fw/decoractors/AutoUnsubscribe';
import {FormBuilder, FormGroup} from "@angular/forms";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {SharedService} from "../../shared/shared.service";
import {Router} from "@angular/router";
import {DtoCustomerSearch} from "./models/DtoCustomerSearch";
import {CustomerSearchService} from "./customer-search.service";
import {DtoCustomerFilter} from "./models/DtoCustomerFilter";
import {FormService} from "../../../fw/services/form.service";


@Component({
    selector: 'app-customer-search',
    template: require('./customer-search.component.html'),
    styles: [require('./customer-search.component.css')]
})

@AutoUnsubscribe()
export class CustomerSearchComponent implements OnInit {
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    filterHeaderConfig: PageHeaderBarConfig = {
        title: 'ZOEKOPTIES',
        buttonDefinition: [
            {
                description: 'ZOEKEN',
                clickEventType: 'search',
                isSmall: false
            },
            {
                description: 'WISSEN',
                clickEventType: 'clear',
                isSmall: false
            }
        ]
    };
    activeItems: Array<{ text: string, value: boolean }> = [
        { text: "Ja", value: true },
        { text: "Nee", value: false }
    ];

    filterForm: FormGroup = this.fb.group({
        firstName: null,
        zipcode: null,
        customerNo: null,
        phoneNo: null,
        lastName: null,
        city: null,
        birthDate: null,
        showInactive: false
    });
    pshbConfig: PageSubheaderBarConfig = {
        title: 'ZOEKRESULTATEN',
        buttonDefinition: [
            {
                clickEventType: 'open',
                description: 'DETAILS',
                isSmall: false
            }
        ]
    };
    data: DtoCustomerSearch[];
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'lastVisitColor',
            color: 'lastVisitColor',
            textColor: 'lastVisitColor',
            label: '',
            type: 'color',
            width: '32px'
        },
        {
            key: 'profilePicture',
            label: '',
            type: 'image',
            width: '120px',
            style: 'grid-image-column'
        },
        {
            key: 'customerNo',
            label: 'Klantnummer',
            type: 'number',
            width: '120px'
        },
        {
            key: 'name',
            label: 'Naam',
            type: 'string',
            width: '*'
        },
        {
            key: 'street',
            label: 'Straat',
            type: 'string',
            width: '*'
        },
        {
            key: 'zipcode',
            label: 'Postcode',
            type: 'string',
            width: '100px'
        },
        {
            key: 'city',
            label: 'Woonplaats',
            type: 'string',
            width: '200px'
        },
        {
            key: 'phoneNo',
            label: 'Telefoonnummer',
            type: 'string',
            width: '150px'
        },
        {
            key: 'birthdate',
            label: 'Geb. datum',
            type: 'string',
            width: '130px',
            format: '{0:dd-MM-yyyy}'
        },
        {
            key: 'gender',
            label: 'M/V',
            type: 'string',
            width: '70px'
        }
    ];

    constructor(private breadcrumService: BreadcrumService,
                private fb: FormBuilder,
                private ss: SharedService,
                private ds: CustomerSearchService,
                private fs: FormService,
                private router: Router) { }

    ngOnInit() {
        let steps: Array<BreadcrumStep> = [
            { text: 'hoofdmenu', isLastStep: false },
            { text: 'klanten', isLastStep: false },
            { text: 'klant zoeken', isLastStep: true }];
        this.breadcrumService.setCurrentLocation(steps, true, 'home');
    }

    loadData() {
        let filter = this.fs.patchFormToDto({} as DtoCustomerFilter, this.filterForm);
        filter.showProfilePicture = true;

        this.ds.searchCustomers(filter, 1, 50).subscribe((res: DtoCustomerSearch[]) => {
            this.data = res;
            this.data.forEach(item => {
                item.lastVisitColor = this.ss.removeColorAlpha(item.lastVisitColor);
            });
            this.filterData();
        });
    }

    filterData() {
        this.grid.hasImages = this.dataHasImages(this.data);
        this.grid.showData(this.data);
    }

    dataHasImages(checkData: DtoCustomerSearch[]) {
        let foundImage = false;
        if (checkData) {
            checkData.forEach((item) => {
                if (item.profilePicture) {
                    foundImage = true;
                }
            });
        }

        return foundImage;
    }

    phbBtnClicked(event) {
        if (event == 'search') {
            this.loadData();
        } else if (event == 'clear') {
            this.filterClear();
        }
    }

    filterClear() {
        this.filterForm.reset({ showInactive: false });
        this.grid.clearData();
    }

    onFilterEnter(event) {
        this.loadData();
    }

    onFilterEsc(event) {
        this.filterClear();
    }

    pshbBtnClicked(event) {
        if (event == 'open') {
            if (this.grid.getSelectedId() > 0) {
                this.router.navigate(['/auth/customer', this.grid.getSelectedId()]);
            }
        }
    }

    gridRowdoubleClicked(event) {
        if (this.grid.getSelectedId() > 0) {
            this.router.navigate(['/auth/customer', this.grid.getSelectedId()]);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/customers/customer-search/customer-search.component.ts